import React, { ReactType, FunctionComponent, ReactElement } from 'react';
import * as authenticate from './index';

export const withAuthenticate =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (WrappedComponent: ReactType): FunctionComponent<any> =>
    function WrappedComponentWithAuthentication({ ...props }): ReactElement {
      return <WrappedComponent {...props} authenticate={authenticate} />;
    };
